/* Built In Imports */
import { useRouter } from 'next/router';

/* External Imports */
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  ModalCloseButton,
  Image,
  Text,
} from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';
import { getUtmParamsFromUrl } from '@components/Utility/utils';

/* Internal Imports */
/* Component */
import SimpleButton from '../../components/Buttons/SimpleButton';
import { mixPanel } from '@utils/Mixpanel';
import config from '@config';
import { useSearchParams, usePathname } from 'next/navigation';
import NextLink from 'next/link';
/* Styles */
/* Services */

/**
 *
 * @param {Object} pageData
 * @param {String} lang
 * @param {String} region
 * @returns {ReactElement} PricingPopup
 */
const WPChatButton = ({ lang, region, isPopup, setIsPopup, pageData }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const isWavesOfBlissUPPage = pathname.includes('wave-of-bliss-uttar-pradesh');

  const [dataJson] = pageData?.pageConfig?.[0]?.value?.chatbot || [{}];

  const {
    title = '',
    button: buttonText = '',
    terms1 = '',
    terms2 = '',
    link = '',
  } = dataJson || {};

  const getBengaluruPageUrl = () => {
    const sourceValue = searchParams.get('utm_source');
    const mediumValue = searchParams.get('utm_medium');

    if (mediumValue === 'cpc' && sourceValue === 'facebook') {
      return 'https://api-ishangam.isha.in/widget/7/whatsapp-redirect?utm_campaign=1694&utm_medium=4251&utm_source=26123&utm_content=2&utm_term=400';
    } else if (mediumValue === 'cpc' && sourceValue === 'google') {
      return 'https://api-ishangam.isha.in/widget/7/whatsapp-redirect?utm_campaign=1694&utm_medium=4252&utm_source=26123&utm_content=2&utm_term=400';
    } else {
      return 'https://api-ishangam.isha.in/widget/7/whatsapp-redirect?utm_campaign=1694&utm_medium=1&utm_source=26123&utm_content=2&utm_term=400';
    }
  };

  const getLucknowLink = link => {
    const sourceValue = searchParams.get('utm_source');
    const mediumValue = searchParams.get('utm_medium');
    const utmCampaignValue = searchParams.get('utm_campaign');
    const contentValue = searchParams.get('utm_content');

    const isMatchCondition =
      utmCampaignValue === 'ie_wave_lucknow' &&
      sourceValue === 'landing_page' &&
      mediumValue === 'waba';
    if (isMatchCondition && contentValue === 'hindi') {
      return 'https://api-ishangam.isha.in/widget/7/whatsapp-redirect?text=I%E2%80%99m%20interested%20in%20Inner%20Engineering%20%E2%80%93%20A%20Wave%20of%20Bliss%2C%20Lucknow&utm_campaign=1699&utm_medium=61&utm_source=26123&utm_content=115&utm_term=400';
    } else if (isMatchCondition && contentValue === 'english') {
      return 'https://api-ishangam.isha.in/widget/7/whatsapp-redirect?text=I’m interested in Inner Engineering – A Wave of Bliss%2C Lucknow&utm_campaign=1699&utm_medium=61&utm_source=26123&utm_content=2&utm_term=400';
    } else {
      return link;
    }
  };

  const mixPanelEventTrigger = () => {
    const Mixpanel = mixPanel(window?.location.pathname);
    Mixpanel.track('ie_wave_continue_to_chat_click', {
      page_name: 'Whatsapp Bot page',
      element: 'Continue to Chat',
      language: config?.lngList?.[lang],
    });
  };

  return (
    <Drawer
      isOpen={isPopup}
      placement={isMobile ? 'bottom' : 'right'}
      onClose={() => {
        setIsPopup(false);
      }}
      size="full"
    >
      <DrawerOverlay />
      <DrawerContent
        background={'rgba(0, 0, 0, 0.1)'}
        h={{ base: 'auto', md: '100vh' }}
        mt={{ base: 'auto', md: '0' }}
      >
        <DrawerBody
          display="flex"
          justifyContent="center"
          alignItems="center"
          p={{ base: '0px !important' }}
        >
          <Box
            maxW={{ base: '100%', md: '604px' }}
            mx="auto"
            width="100%"
            background="#ffffff"
            pos="relative"
            maxH="100%"
            overflowY="auto"
            px={{ base: '16px', md: '25px' }}
            py={{ base: '21px', md: '16px' }}
            borderRadius={{ base: '24px 24px 0px 0px', md: '12px' }}
          >
            <ModalCloseButton />
            <Flex flexDirection={'column'} mt={{ base: '15px', md: '12px' }}>
              <Image
                src="/assets/images/logo.png"
                alt="Isha Foundation"
                mx="auto"
                h="58px"
              />

              <Text
                fontSize={{ base: '16px', md: '18px' }}
                mb={{ base: '27px', md: '37px' }}
                mt={{ base: '17px', md: '18px' }}
                textAlign={'center'}
                fontFamily={'FedraSansStd-medium'}
                fontWeight={'450'}
                color={'#000000'}
              >
                {title || 'Isha Foundation'}
              </Text>

              <NextLink
                href={
                  isWavesOfBlissUPPage
                    ? getLucknowLink(link)
                    : getBengaluruPageUrl()
                }
                passHref
                legacyBehavior
              >
                <SimpleButton
                  id="waves-of-bliss-wa-continue-button"
                  minW="181px"
                  background={'#128C7E !important'}
                  h={{ base: '43px' }}
                  minH={{ base: '43px' }}
                  textAlign="center"
                  mb={'0'}
                  mt={'0'}
                  mx={{ base: 'auto', md: '0', lg: 'auto' }}
                  _hover={{
                    background: '#128C7E !important',
                  }}
                  borderRadius={'50px !important'}
                  style={{
                    buttonStyle: 'Orange',
                    buttonText: buttonText || 'Continue to Chat',
                    linkUrl: link,
                  }}
                  onClick={() => {
                    mixPanelEventTrigger();
                  }}
                  padding={{
                    base: '10px 26px',
                  }}
                  lineHeight={{
                    base: '23px',
                  }}
                  color={'#fff'}
                  fontSize={{ base: '14px', md: '16px' }}
                  zIndex={100}
                  useBlankStringURLOnLink
                />
              </NextLink>

              <Text
                fontSize="14px"
                mt={{ base: '17px', md: '42px' }}
                color="#566666"
                textAlign={'center'}
                mx={{ base: '40px', md: 'auto' }}
                mb={{ base: '9px', md: '20px' }}
                fontFamily={'FedraSansStd-medium'}
                lineHeight={'16px'}
                fontWeight={'500'}
              >
                {terms1 || 'I have read, understood and agree to the'}{' '}
                <Box
                  as="a"
                  href={`${config.BASE_PATH}/in/en/copyright-privacy-policy-terms#privacy`}
                  textDecorationLine="underline"
                  target="_blank"
                >
                  {terms2 || 'Privacy Policy'}
                </Box>{' '}
              </Text>
            </Flex>
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default WPChatButton;
